import React from "react";
import { useTranslation } from "react-i18next";

import { BackgroundContact } from "../../components/background";
import Header from "../../components/header";
import Spacer from "../../components/spacer";
import FormInput from "../../components/formInput";
import Footer from "../../components/footer";
import "react-phone-number-input/style.css";
import PagesHeadLine from "../../components/pagesHeadline";

import "./styles.css";

function ContactPage() {
  const { t } = useTranslation();

  return (
    <div className="App">
      <BackgroundContact />
      <div className="contact-page-container">
        <Header />
        <PagesHeadLine content={t("contact.headline")}></PagesHeadLine>
        <div className="contact-page-content-container">
          <div className="contact-page-form-container">
            <form className="contact-form">
              <FormInput
                label={t("contact.forms.name")}
                type="text"
                placeholder={t("contact.forms.namePlaceholder")}
              />
              <FormInput
                label={t("contact.forms.email")}
                type="email"
                placeholder={t("contact.forms.emailPlaceholder")}
              />
              <div className="input-group">
                <FormInput
                  label={t("contact.forms.phone")}
                  type="tel"
                  placeholder="(XX) XXXXX-XXXX"
                  extraClass="phone-input"
                  phone={true}
                />
                <FormInput
                  label={t("contact.forms.area")}
                  type="text"
                  placeholder={t("contact.forms.areaPlaceholder")}
                />
              </div>

              <FormInput
                label={t("contact.forms.description")}
                type="textarea"
                placeholder={t("contact.forms.descriptionPlaceholder")}
                extraClass="textarea-input"
              />

              <button type="submit" className="submit-button">
                {t("contact.forms.button")}
              </button>
            </form>
          </div>
          <Spacer space="6" />
        </div>
        <Footer />
      </div>
    </div>
  );
}
export default ContactPage;
